import { FormEvent } from 'react';
import { chatListAsset, ENTRY_LEVEL_OPTIONS } from './chatListShared';

interface ChatListSearchPanelProps {
  variant: 'mobile' | 'desktop';
  open: boolean;
  searchTitle: string;
  searchLevel: string;
  onSearchTitleChange: (value: string) => void;
  onSearchLevelChange: (value: string) => void;
  onSubmit: (e: FormEvent) => void;
  onClose: () => void;
}

export default function ChatListSearchPanel({
  variant,
  open,
  searchTitle,
  searchLevel,
  onSearchTitleChange,
  onSearchLevelChange,
  onSubmit,
  onClose,
}: ChatListSearchPanelProps) {
  if (!open) return null;

  return (
    <>
      <form
        className={`show-search chat-list-search-panel chat-list-search-panel--${variant}${open ? ' active-search' : ''}`}
        onSubmit={onSubmit}
      >
        <div>
          <h3>
            <span><img src={chatListAsset('search-home.png')} alt="" /></span>
            방제목
          </h3>
          <input
            type="text"
            className="form-control"
            value={searchTitle}
            onChange={(ev) => onSearchTitleChange(ev.target.value)}
            placeholder="방제목을 입력하세요"
          />
        </div>
        <div>
          <h3>
            <span><img src={chatListAsset('out.png')} alt="" /></span>
            입장레벨
            <span className="text-red">※입장레벨만 선택해서 검색가능</span>
          </h3>
          <select
            className="form-control"
            value={searchLevel}
            onChange={(ev) => onSearchLevelChange(ev.target.value)}
          >
            {ENTRY_LEVEL_OPTIONS.map((opt) => (
              <option key={opt.value || 'all'} value={opt.value}>{opt.label}</option>
            ))}
          </select>
        </div>
        <button type="submit" className="btn button-red">
          <img src={chatListAsset('search-w.png')} alt="" />
          검색
        </button>
        <button type="button" className="btn btn-info chat-search-close" onClick={onClose}>
          닫기
        </button>
      </form>
      <button
        type="button"
        className="chat-search-backdrop"
        aria-label="검색 닫기"
        onClick={onClose}
      />
    </>
  );
}
